export default "__VITE_ASSET__DVCfiUJB__"